import { gql } from '@apollo/client';

export const CONVERSATIONS_QUERY = gql`
  query Conversations($filter: ConversationsFilterInput) {
    conversations(filter: $filter) {
      edges {
        node {
          id
        }
      }
    }
  }
`;

export const GET_BLOCKED_USERS = gql`
  query GetBlockedUsers {
    blockedConversationUsers {
      edges {
        node {
          id
          name
          blockedAt
        }
      }
    }
  }
`;

export const SEARCHABLE_DM_USERS_QUERY = gql`
  query SearchableDmUsers($searchTerm: String, $first: Int = 5, $userGids: [String!]) {
    site {
      searchableDmUsers(
        searchTerm: $searchTerm
        searchFilters: NAME
        first: $first
        userGids: $userGids
      ) {
        edges {
          node {
            user {
              id
              fullName
              gid
              profile {
                avatar {
                  url
                  altText
                }
              }
            }
          }
        }
      }
    }
  }
`;
